module.exports = __webpack_public_path__ + "static/media/card-front.17dc3ed5.png";